import { ServerError } from "./errors";
import { z } from "zod";

type ApiCallParams<T extends z.ZodSchema> = {
  url: string;
  authorizationToken: string;
  method?: "GET" | "POST";
  requestBody?: unknown;
  mode?: RequestInit["mode"];
  responseSchema: T;
};
export const apiCall = async <T extends z.ZodSchema>({
  url,
  authorizationToken,
  method = "GET",
  requestBody,
  mode,
  responseSchema,
}: ApiCallParams<T>): Promise<z.infer<T>> => {
  const requestInit: RequestInit = {
    method,
    headers: {
      Authorization: "Bearer " + authorizationToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
    mode,
  };

  const response = await fetch(url, requestInit);

  if (response.status !== 200) throw await ServerError.fromResponse(response);

  return responseSchema.parse(await response.json());
};
